module.exports = __webpack_public_path__ + "img/Opencart.05d3872.svg";